import { Injectable } from '@angular/core';
import {ApiService} from '../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class VnaClientService {

  constructor(private api:ApiService) { }

  getClientList():Observable<any>{
    return this.api.get('vna/client');
  }

  removeClient(pk:number): Observable<any>{
      return this.api.remove('vna/client',pk);
  }

  postClient(client:Object): Observable<any>{
      return this.api.post('vna/client',client);
  }

  putClient(client:any):Observable<any>{
      return this.api.put('vna/client',client.pk,client);
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/client/management/service/vna-client.service.ts